import { render, staticRenderFns } from "./McrFormB5.vue?vue&type=template&id=4f353e48"
import script from "./McrFormB5.vue?vue&type=script&lang=js"
export * from "./McrFormB5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports